import React from "react";
import "./VideoSection.css";

const VideoSection = ({ title, description, videoSrc }) => {
  return (
    <div className="video-section-container">
      <h2 className="video-section-title">{title}</h2>
      <p className="video-section-description">{description}</p>
      <div className="video-wrapper">
        <iframe
          src={videoSrc}
          title="Introduction Video"
          allow="encrypted-media; gyroscope"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default VideoSection;
